var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTopSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#989be1",
    d: "M50 0c-27.614 0-50 22.385-50 49.999 0 27.615 22.386 50.001 50 50.001s50-22.386 50-50.001c0-27.614-22.386-49.999-50-49.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D5D5",
    d: "M78.559 27.014l1.427 1.428-37.697 33.551-4.283-4.283 40.553-30.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M61 76.999v6h-6v-6h-2v6h-6v-6h-2v6h-6v-6h-2v8h26v-8h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC75E",
    d: "M47.031 8.094c-15.203 1.044-28.29 10.351-34.742 23.434l5.424 2.656c5.767-11.646 17.669-19.813 31.333-20.166.32-.008.636 0 .954 0v-6.014c-.983 0-1.971.021-2.969.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2574C",
    d: "M85.985 49.988c0 5.471-1.437 10.873-3.686 15.61-.689 1.452-.172 3.182 1.235 3.976l.054.03c1.564.882 3.537.234 4.305-1.381 2.63-5.533 4.107-11.843 4.107-18.235 0-7.042-1.743-13.672-4.807-19.5l-5.326 2.794c2.624 4.993 4.118 10.674 4.118 16.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DB39E",
    d: "M16.407 69.613l.054-.029c1.408-.775 1.924-2.467 1.234-3.887-2.439-5.021-3.886-11.12-3.658-17.104.209-5.493 1.686-10.681 4.13-15.293l-5.356-2.81c-2.57 4.867-4.211 10.29-4.674 16.029-.619 7.668.863 15.368 3.965 21.744.767 1.578 2.74 2.213 4.305 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B459",
    d: "M50 8.004v6.014c14.174.001 26.436 8.185 32.301 20.095l5.392-2.652c-6.847-13.899-21.151-23.454-37.693-23.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324D5B",
    d: "M76.559 22.014l1.427 1.428-35.697 38.551-4.283-4.283 38.553-35.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2D36",
    d: "M50 44.999c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopSpeed);
export default __webpack_public_path__ + "static/media/iconTopSpeed.5675cf77525265850c5d74f47b7593ee.svg";
export { ForwardRef as ReactComponent };